import React from 'react';

//Estilos base:
let mainCardStyle = {
    paddingTop: 20
};

export const downloadSourcesResumeTourConfig = [
    {
        selector: '',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Bienvenido al <b>{process.env.REACT_APP_CRAWLER_OWNER + ' Crawler'}</b>. A continuación, te guiaremos en los primeros pasos
                , haciendo énfasis la pantalla principal: <b>Fuentes de descarga</b>.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__downloadSourcesResume.downloadSourceCard"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Cada una de estas tarjetas te permite controlar <b>una fuente de descarga</b>.</p>
                <p>La información desplegada corresponde a la <b>información clave</b> de la fuente
                    y al resultado de la <b>última ejecución</b>.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__downloadSourcesResume.downloadSourceCardTitle"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Encontrarás el <b>nombre de la fuente</b>.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__downloadSourcesResume.downloadSourceCardHyperlink"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>El hipervínculo a través del cual el crawler ejecutará el proceso
                     de <b>descarga de la información</b>.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__downloadSourcesResume.downloadSourceCardLastExecutionDate"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>La fecha de la <b>última ejecución</b> de descarga, o de la siguiente <b>ejecución automática</b> si lo has configurado previamente.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__downloadSourcesResume.downloadSourceCardExecutionButton"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>El botón más importante: el de <b>ejecutar</b> para iniciar un
                <b> nuevo proceso de descarga</b>.</p>
                <p>Este botón requiere permisos...</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__downloadSourcesResume.downloadSourceCardStatusButton"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Y la descripción del <b>resultado</b> de la última descarga.</p>
                <p>Si haces clic en esta zona, accederás a los <b>detalles</b> del proceso.</p>
                <p>Podrás encontrar <b>cuatro estados</b>: finalizado; error; en proceso y sin ejecutar.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__downloadSourcesResume.viewModeButton"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Puedes utilizar este botón, para cambiar a una <b>vista más compacta</b> basada en una tabla.</p>
                <p>La información que encontrarás es la misma que con el modo de tarjetas.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__downloadSourcesResume.helpButton"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Recuerda que puedes acceder a la ayuda <b>siempre que sea necesario</b>, haciendo clic en este botón.</p>
                <p>La ayuda se <b>adaptará</b> a cada pantalla en la que estés.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__mainLayout.logoutButton"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Por último, para <b>cerrar tu sesión</b>, haz clic en este botón.</p>
            </div>
        )
    },
];